import { type TextareaHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Textarea variant definitions — the multi-line sibling of `ui/input`, sharing
 * its surface/border/focus treatment.
 */
const textareaVariants = cva(
  [
    'w-full font-sans text-primary bg-surface',
    'border border-border rounded-card px-4 py-3',
    'placeholder:text-muted',
    'focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent',
    'disabled:opacity-50 disabled:pointer-events-none',
    'transition-colors resize-none',
  ].join(' '),
  {
    variants: {
      textareaSize: {
        sm: 'min-h-16 text-sm',
        md: 'min-h-20 text-base',
      },
    },
    defaultVariants: {
      textareaSize: 'sm',
    },
  },
);

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & VariantProps<typeof textareaVariants>;

export { textareaVariants };
